import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import {
  TUpdateLocationsPayload,
  TUpdateLocationsResponse,
} from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EHttpService, EServerPath, TErrorResponse } from '~/models/api'
import HttpService from '~/services/http'
import { HttpServiceBaseResponse } from '~/services/http/models'
import { store } from '~/store'

const updateLocations = async ({
  orgId,
  payload,
}: {
  orgId: string
  payload: TUpdateLocationsPayload
}) =>
  HttpService.patch<TUpdateLocationsResponse>(
    {
      path: EServerPath.locations,
      query: { orgId },
      payload,
    },
    EHttpService.agent,
  )

function useUpdateLocations() {
  const queryClient = useQueryClient()
  const orgId = store((state) => state.user.organizationId) || ''

  return useMutation<
    HttpServiceBaseResponse<TUpdateLocationsResponse>,
    TErrorResponse,
    TUpdateLocationsPayload
  >({
    mutationFn: (payload) => updateLocations({ orgId, payload }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.locations(orgId),
      })
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        'Could not update location. Please try again.'

      toast.error(message)
    },
  })
}

export default useUpdateLocations
